import { RoleState } from './roles.state'

export class RoleUpdaters {
  static setRoles(state: RoleState, newRoles: RoleState['entities']): RoleState {
    const allRoles = [...state.entities, ...newRoles]
    const uniqueRoles = Array.from(new Map(allRoles.map((role) => [role.id, role])).values())

    return {
      ...state,
      entities: uniqueRoles,
      isLoading: false,
      error: null,
    }
  }
}
